import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { fluidType } from '../../../utils/helpers'

// Return font based on type
const fontType = (type) => {
  if (type === 'title') {
    return 'BarlowExtraBold'
  } else if (type === 'subtitle') {
    return 'BarlowSemiBold'
  } else {
    return 'Barlow'
  }
}

const StyledBase = styled.div`
  font-family: ${props => fontType(props.type)};
  color: ${props => props.color || props.theme.color.textPrimary};
  font-style: ${props => props.italics && 'italic'};
  padding: ${props => props.padding};
`

const Header1 = StyledBase.withComponent('h1').extend`
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      props.theme.fontSize.mobile.h1,
      props.theme.fontSize.desktop.h1
    )
};
  text-transform: uppercase;
`

const Header2 = StyledBase.withComponent('h2').extend`
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      props.theme.fontSize.mobile.h2,
      props.theme.fontSize.desktop.h2
    )
};
  text-transform: uppercase;
`

const Header3 = StyledBase.withComponent('h3').extend`
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      props.theme.fontSize.mobile.h3,
      props.theme.fontSize.desktop.h3
    )
};
  text-transform: uppercase;
`

const Header4 = StyledBase.withComponent('h4').extend`
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      props.theme.fontSize.mobile.h4,
      props.theme.fontSize.desktop.h4
    )
};
  text-transform: uppercase;
`

const Header5 = StyledBase.withComponent('h5').extend`
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      props.theme.fontSize.mobile.h5,
      props.theme.fontSize.desktop.h5
    )
};
  text-transform: uppercase;
`

const Body = StyledBase.withComponent('p').extend`
  font-size: ${props => props.size || props.theme.fontSize.desktop.body};
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      props.minSize,
      props.maxSize
    )
};
`
const Small = StyledBase.withComponent('span').extend`
  font-size: ${props => props.theme.fontSize.desktop.small};
`

const Large = StyledBase.withComponent('h1').extend`
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      props.theme.fontSize.mobile.large,
      props.theme.fontSize.desktop.large
    )
};
  text-transform: uppercase;
`

const Typography = ({ variant, children, ...props }) => {
  // Add line breaks to string by checking for ;
  if (typeof children === 'string' && children.includes(';')) {
    children = children.split(';').map((item, key) => {
      return <span key={key}>{item}<br /></span>
    })
  }
  if (variant === 'h1') {
    return <Header1 {...props}>{children}</Header1>
  }
  if (variant === 'h2') {
    return <Header2 {...props}>{children}</Header2>
  }
  if (variant === 'h3') {
    return <Header3 {...props}>{children}</Header3>
  }
  if (variant === 'h4') {
    return <Header4 {...props}>{children}</Header4>
  }
  if (variant === 'h5') {
    return <Header5 {...props}>{children}</Header5>
  }
  if (variant === 'small') {
    return <Small {...props}>{children}</Small>
  }
  if (variant === 'large') {
    return <Large {...props}>{children}</Large>
  }

  return <Body {...props}>{children}</Body>
}

Typography.propTypes = {
  /**
   * Specify variant - h1, h2, h3, h4, h5, body,small
   */
  variant: PropTypes.string,

  /**
   * Specify type (font-weight) - title, subtitle else fallsback to regular
   */
  type: PropTypes.string,

  /**
   * Specify size (font-size) override for body text
   */
  size: PropTypes.string,

  /**
   * Content for the Typography
   */
  children: PropTypes.node.isRequired
}

Typography.defaultProps = {
  variant: 'body',
  children: 'Hello World!'
}

export default Typography



// WEBPACK FOOTER //
// ./src/components/UI/Typography/index.js